module.exports = __webpack_public_path__ + "static/media/S3N11-3.6c6ef3a1.svg";